//filters
const filters = {
    // 清空字符串内的数字信息
    replaceNumber: val => {
        return val.replace(/(\d+(\.\d+)?(,\d+)?)/, "");
    },
    // 去掉厨卫信息
    replaceKS: val => {
        if (!val) {
            return '';
        }
        return val.replace(/(\d+卫)/, "").replace(/(\d+厨)/, '');
    },
    // common phone check
    checkPhone: value => {
        if (!value) return false;
        return /^[1][3-9]\d{9}$/.test(value);
    },
    // common tel check
    checkTel: value => {
        if (!value) return false;
        return /^\d{3,4}\-\d{7,14}$/.test(value);
    },
    // 清空字符串内的文字信息
    parseFloat: val => {
        // 4,234 带 ， 的数字不做 parseFloat 处理
        if (/^\d+,\d+$/.test(val)) {
            return val;
        }
        return parseFloat(val.replace(/([万亿])/, ""));
    },
    // 格式化数字，如果小数点后带零，把0去掉，否则保留小数点
    removeLastZero: val => {
        // 如果不是数字 或者 小数 直接返回
        if (!/(\d+(\.\d+)?)/.test(val)){
            return val;
        }
        let _intNum = parseInt(val);
        return _intNum == val ? _intNum : val;
    },
    thousandPrice: price => {
        if (!price) return 0;
        var p=price.toString().split('.');
        return p[0].replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1,')+(p[1]?'.'+p[1]:'')
    },
    mixPrice:(price, flag,type) => {
        return Vue.instance.$store.getters.mixPrice(price,flag,type);
    },
    // 日期格式化, 返回 X年X月X日 addZero 表示是否月份不满10月要追加0， 默认不追加
    dateFormat: (val, addZero = false, unit = ['年', '月', '日'], reg = /(\d{4})[-/](\d{1,2})[-/](\d{1,2})/) => {
        let match = val.match(reg);
        //未匹配成功返回原数值
        if (!match) return val;
        let [, year, month, day] = match;
        let [yUnit, mUnit, dUnit] = unit;
        if (addZero) {
            if(month < 10) {
                month = `0${month}`;
            }
            if(day < 10) {
                day = `0${day}`;
            }
        }
        return `${year}${yUnit}${month}${mUnit}${day}${dUnit}`;
    },
    // 电话格式化
    telFormat: val => {
        return val.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
    },
    // 切割字符串
    splitString: (str, len, remain = '…') => {
        if(!str || (str && str.length < len)) return str;
        return str.substr(0, len) + remain;
    }
}

// register to vue  filter
for(let key in filters) {
    Vue.filter(key, filters[key])
}


// WEBPACK FOOTER //
// ./src/assets/js/filters.js